export default __webpack_public_path__ + "static/media/rain-1.f852b364.png";